// test class to test app. It will have methods which generate valid and invalid values for forms.
// First method should generate random valid values for contact form.
// Second method should generate random invalid values for address form.
// import json files

import { emails } from "./emails";
import { first_names } from "./first_names";
import { last_names } from "./last_names";
import { type AddressData, merged } from "./merged_sample";
import { phone_numbers } from "./phone_numbers";

interface ContactFormData {
	firstName: string;
	lastName: string;
	email: string;
	phoneNumber: string;
	title: string;
}

export class Test {
	// generate random valid values for contact form
	addressForm(): AddressData {
		// const businessName = business_names[Math.floor(Math.random() * business_names[0].length)];
		// const city = cities[Math.floor(Math.random() * cities[0].length)];
		// const buildingNumber = Math.floor(Math.random() * 1000);
		// const streetName = streets[Math.floor(Math.random() * streets[0].length)];
		// const postcode = postcodes[Math.floor(Math.random() * postcodes[0].length)];
		// // capital alphabetical letters
		// const letters = "ABCDEFGH";

		// const flat = `Property ${Math.floor(Math.random() * 35)}${
		//   Math.random() > 0.5 ? letters[Math.floor(Math.random() * letters.length)] : ""
		// }`;

		// //capitalise each word in street name
		// const streetName_2 = streetName
		//   .toLowerCase()
		//   .split(" ")
		//   .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
		//   .join(" ");

		// // random true or false
		// const isBusiness = Math.random() > 0.5;
		// const isProperty = isBusiness ? false : Math.random() > 0.5;
		// const isBuildingName = Math.random() > 0.5;
		// return {
		//   flat: isProperty ? flat : "",
		//   businessName: isBusiness ? businessName : undefined,
		//   city: city,
		//   buildingNumber: isBuildingName
		//     ? buildingNumber + " " + letters[Math.floor(Math.random() * letters.length)]
		//     : buildingNumber,
		//   streetName: streetName_2,
		//   postcode: postcode,
		// };

		// random from merged
		return merged[Math.floor(Math.random() * merged.length)];
	}

	// generate random postcode from merged
	postcode(): string {
		return merged[Math.floor(Math.random() * merged.length)].postcode;
	}

	// generate random valid values for contact form
	contactForm(): ContactFormData {
		const firstName =
			first_names[Math.floor(Math.random() * first_names.length)];
		const lastName = last_names[Math.floor(Math.random() * last_names.length)];
		const email = emails[Math.floor(Math.random() * emails.length)];

		// generate 1000 fake mobile numbers starting with 07 and 9 random numbers
		const mobileNumbers: string[] = [];
		for (let i = 0; i < 1000; i++) {
			mobileNumbers.push(`07${Math.floor(Math.random() * 999999999)}`);
		}

		const phoneNumber = [...phone_numbers, ...mobileNumbers][
			Math.floor(Math.random() * (phone_numbers.length + 1000))
		];
		const titles = ["Mr", "Mrs", "Miss", "Ms", "Dr"] as const;
		const title = titles[Math.floor(Math.random() * titles.length)];

		return {
			firstName: firstName,
			lastName: lastName,
			email: email,
			phoneNumber: phoneNumber,
			title: title,
		};
	}
}

const test = new Test();

// define on global
// biome-ignore lint/suspicious/noExplicitAny: Required for global window assignment
(window as any).Test = test;

export default test;
